import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["PoolsContent"] */ "/app/src/app/[locale]/(main)/(home)/_components/Pools/PoolsContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoPlayer"] */ "/app/src/app/[locale]/(main)/(home)/_components/Pools/VideoPlayer.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/green-checked.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/loaderButton.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/pools.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/accordion.tsx");
